const MAP = {
  critical: { fg: "#FF3B30", bg: "rgba(255,59,48,0.10)", label: "CRITICAL" },
  high:     { fg: "#FF9F0A", bg: "rgba(255,159,10,0.10)", label: "HIGH" },
  medium:   { fg: "#FFCC00", bg: "rgba(255,204,0,0.10)",  label: "MEDIUM" },
  low:      { fg: "#34C759", bg: "rgba(52,199,89,0.10)",  label: "LOW" },
  info:     { fg: "#8E9196", bg: "rgba(142,145,150,0.10)", label: "INFO" },
  error:    { fg: "#FF3B30", bg: "rgba(255,59,48,0.10)",  label: "ERROR" },
  warning:  { fg: "#FF9F0A", bg: "rgba(255,159,10,0.10)", label: "WARN" },
};

export default function SeverityBadge({ severity, testid }) {
  const key = (severity || "info").toLowerCase();
  const cfg = MAP[key] || MAP.info;
  return (
    <span
      data-testid={testid || `severity-${key}`}
      className="inline-flex items-center px-2 py-0.5 border rounded-sm font-mono text-[10px] font-semibold tracking-wider uppercase"
      style={{ color: cfg.fg, borderColor: cfg.fg + "55", background: cfg.bg }}
    >
      {cfg.label}
    </span>
  );
}
